<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-identification_checked"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      :type="'checkbox'"
      :checkbox_checked_value="true"
      :disabled="true"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "IdentificationChecked",
  components: {InputWidget},
  mixins: [BaseInputMixin('term.identification_checked')],

  data() {
    return {
      defaultLabel: this.$t("Identification Checked")
    }
  }
}
</script>

<style scoped>

</style>
